/**
 * Esto lo que hace es registrar automáticamente todos los componentes Vue
 * que estén en este directorio y los registra como tags globales que empiezan por cifra-.
 * Por ejemplo, si tenemos un componente llamado `ModalSimple.vue`, se registrará
 * como `<cifra-modal-simple></cifra-modal-simple>`.
 */
export default {
  install: (app, _options) => {
    // Grab all components in `/src/lib/components/` that start with "Base"
    const components = import.meta.glob('./*.vue', { eager: true });
    Object.entries(components).forEach(([path, component]) => {
      const pathSplit = path.split('/')
      const fileName = pathSplit[pathSplit.length - 1].split('.vue')[0]

      app.component(`Cifra${fileName}`, component.default)
    })
  },
};
